module.exports = __webpack_public_path__ + "static/media/list.8c23face.svg";